import { useTranslation } from "react-i18next";
import { ArrowRight, CalendarClock, Mail, Mic } from "lucide-react";

const IMG = "/nuvli/nuvli-portada.jpg";
const ICONOS = [Mail, CalendarClock, Mic];

export function SeccionNuvli() {
  const { t } = useTranslation();
  const puntos = t("home.nuvli.points", { returnObjects: true });
  const irAPlanes = () => document.getElementById("precios")?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <section id="nuvli" className="max-w-6xl mx-auto px-4 sm:px-6 pb-16" data-testid="landing-nuvli">
      <div className="relative grid items-center gap-10 overflow-hidden rounded-3xl bg-[#1B2B4B] p-6 sm:p-10 lg:grid-cols-2 lg:p-12">
        <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-[#00B4CC]/20 blur-3xl pointer-events-none" />
        <div className="relative">
          <span className="inline-block rounded-full border border-[#00B4CC]/50 bg-[#00B4CC]/15 px-3.5 py-1 text-xs font-semibold uppercase tracking-wide text-[#7FE3F0]" data-testid="landing-nuvli-badge">{t("home.nuvli.badge")}</span>
          <h2 className="mt-4 font-heading text-3xl font-extrabold leading-tight text-white md:text-4xl" data-testid="landing-nuvli-title">{t("home.nuvli.title")}</h2>
          <p className="mt-4 text-base text-sky-100/90 md:text-lg" data-testid="landing-nuvli-subtitle">{t("home.nuvli.subtitle")}</p>
          <ul className="mt-6 space-y-3">
            {Array.isArray(puntos) && puntos.map((p, i) => {
              const Icon = ICONOS[i] || Mic;
              return (
                <li key={p} className="flex items-start gap-3 text-sm text-sky-50">
                  <span className="mt-0.5 w-7 h-7 shrink-0 rounded-lg bg-[#00B4CC]/20 text-[#00B4CC] flex items-center justify-center"><Icon className="w-4 h-4" /></span>
                  {p}
                </li>
              );
            })}
          </ul>
          <button type="button" onClick={irAPlanes} className="mt-8 inline-flex h-12 items-center gap-2 rounded-xl bg-[#00B4CC] px-7 font-semibold text-white shadow-lg shadow-[#00B4CC]/30 transition-colors hover:bg-[#009DB3]" data-testid="landing-nuvli-cta">
            {t("home.nuvli.cta")} <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        <div className="relative pb-6">
          <img src={IMG} alt={t("home.nuvli.alt")} loading="lazy" className="aspect-[4/3] w-full rounded-2xl object-cover shadow-2xl ring-1 ring-white/10" data-testid="landing-nuvli-img" />
          <div className="absolute bottom-0 left-4 right-4 sm:right-auto flex items-center gap-2 rounded-xl bg-white px-4 py-2.5 text-sm font-semibold text-[#1B2B4B] shadow-xl">
            <Mic className="w-4 h-4 shrink-0 text-[#00B4CC]" /> <span className="truncate">{t("home.nuvli.example")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
